import React from 'react';
import classNames from 'classnames';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';

/**
 * Label cell
 */
export default React.createClass({
  displayName: 'LabelCell',

  mixins: [HighlightCellMixin],

  propTypes: {
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    isCopied: React.PropTypes.bool,
    editing: React.PropTypes.string, //EditableCellType
    rowType: React.PropTypes.string, //RowType,
    tag: React.PropTypes.object,
    tags: React.PropTypes.array,
  },

  render() {
    const {
      // editing,
      // item,
      // tags,
      // rowSelected,
      // rowIndex,
      rowTags,
      isCopied,
    } = this.props;

    if (rowTags.length < 1) return null;

    let wrapperClasses = classNames('cs-label-cell-wrapper');

    let cellClasses = classNames('cs-label-cell', 'cs-cell', {
      'cs-cell-copied': isCopied,
    });

    const rowTagNodes = [];

    rowTags.forEach((tag) => {
      const tagColor =
        tag.get('text') === 'Unassigned'
          ? '#434343'
          : this._getTxtColor(tag.get('color'));

      rowTagNodes.push(
        <div
          className="cs-label-cell-content"
          style={{
            background: tag.get('color'),
            color: tagColor,
          }}
          key={tag.get('_id')}
        >
          <div className="cs-label-inner">{tag.get('text')}</div>
        </div>,
      );
    });

    return (
      <div className={wrapperClasses}>
        <div className={cellClasses}>{rowTagNodes}</div>
      </div>
    );
  },

  _getTxtColor(hexColor) {
    if (!hexColor) return;

    hexColor = hexColor.replace(/^#+/i, '');

    let r = parseInt(hexColor.substr(0, 2), 16),
      g = parseInt(hexColor.substr(2, 2), 16),
      b = parseInt(hexColor.substr(4, 2), 16);

    let colorSpace = (r * 299 + g * 587 + b * 114) / 1000;

    return colorSpace >= 128 ? 'black' : 'white';
  },
});
